import { render, staticRenderFns } from "./PhotoIcon.vue?vue&type=template&id=0f87905d&scoped=true&"
import script from "./PhotoIcon.vue?vue&type=script&lang=js&"
export * from "./PhotoIcon.vue?vue&type=script&lang=js&"
import style0 from "./PhotoIcon.vue?vue&type=style&index=0&id=0f87905d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f87905d",
  null
  
)

export default component.exports